var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"close-button",attrs:{"color":"primary","fab":"","x-small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"color":"white","size":"25"}},[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }